import { render } from "./SecondStage.vue?vue&type=template&id=253f10d2&scoped=true"
import script from "./SecondStage.vue?vue&type=script&lang=js"
export * from "./SecondStage.vue?vue&type=script&lang=js"

import "./SecondStage.vue?vue&type=style&index=0&id=253f10d2&lang=scss"
import "./SecondStage.vue?vue&type=style&index=1&id=253f10d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253f10d2"]])

export default __exports__